import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject0, _templateObject1, _templateObject10, _templateObject11;
var __jsx = React.createElement;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component, Fragment } from 'react';
import styled, { keyframes } from 'styled-components';
import { colorPalette, themes, textStyles } from '../styles/styleGuide';
import { fromBreakpoint, breakpointSizes } from '../styles/breakpoints';
import PlayIcon from './shared/icons/Play';
import Slider from './shared/ui/Slider';
import ImageLoader from './shared/ui/ImageLoader';
import formatCmsImageUrl from '../services/formatCmsImageUrl';
import UserAvatar from './UserAvatar';
import DownloadButton from './shared/buttons/ButtonDownload';
import { css } from 'styled-components';
var HeroArticle = /*#__PURE__*/function (_Component) {
  function HeroArticle() {
    var _this;
    _classCallCheck(this, HeroArticle);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HeroArticle, [].concat(args));
    _defineProperty(_this, "state", {
      showVideo: false
    });
    _defineProperty(_this, "handleClick", function () {
      _this.setState({
        showVideo: true
      });
    });
    return _this;
  }
  _inherits(HeroArticle, _Component);
  return _createClass(HeroArticle, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        image = _this$props.image,
        type = _this$props.type,
        title = _this$props.title,
        theme = _this$props.theme,
        media = _this$props.media,
        credits = _this$props.credits,
        author = _this$props.author,
        youtubeId = _this$props.youtubeId,
        renderWidth = _this$props.renderWidth,
        showDownloadButton = _this$props.showDownloadButton;
      var showVideo = this.state.showVideo;
      var IMAGE_SIZES = renderWidth && renderWidth > 1000 ? 1180 : 1000;
      var El;
      switch (type) {
        case 'image':
        default:
          El = __jsx(ImageContainer, {
            "data-id": "components_HeroArticle_ImageContainer"
          }, image && image.src && __jsx(Fragment, null, showDownloadButton && __jsx(DownloadButtonBase, {
            "data-id": "components_HeroArticle_DownloadButtonBase"
          }, __jsx(DownloadButton, {
            link: image && image.src ? formatCmsImageUrl(0, 0, image.src, false) : '/',
            content: "",
            image: true,
            "data-id": "components_HeroArticle_DownloadButton"
          })), __jsx(ImageLoader, {
            width: renderWidth,
            height: 900,
            src: image.src,
            alt: title,
            color: themes[theme].secondary,
            mode: "bg",
            "data-id": "components_HeroArticle_ImageLoader"
          })));
          break;
        case 'video':
          El = __jsx(Video, {
            "data-id": "components_HeroArticle_Video"
          }, renderWidth && renderWidth > 720 && __jsx(VideoPlaceholder, {
            image: formatCmsImageUrl(IMAGE_SIZES, 0, image ? image.src : ''),
            size: "large",
            showVideo: showVideo,
            "data-id": "components_HeroArticle_VideoPlaceholder"
          }, __jsx(PlayIconWrapper, {
            onClick: this.handleClick,
            "data-id": "components_HeroArticle_PlayIconWrapper"
          }, __jsx(PlayIcon, {
            color: "#FFFFFF",
            "data-id": "components_HeroArticle_PlayIcon"
          }))), __jsx(YouTubeIFrame, {
            title: title,
            width: "560",
            height: "315",
            src: "https://www.youtube.com/embed/".concat(String(youtubeId), "?rel=0&autoplay=").concat(showVideo ? '1' : '0', "&showinfo=0"),
            frameBorder: "0",
            allowFullScreen: true,
            showVideo: showVideo,
            desktop: renderWidth && renderWidth > 720,
            "data-id": "components_HeroArticle_YouTubeIFrame"
          }));
          break;
        case 'slider':
          El = __jsx(Fragment, null, showDownloadButton && __jsx(Slider, {
            heroes: media,
            showBullets: false,
            showPrimaryArrows: false,
            showSecondaryArrows: true,
            heightRatio: 664 / 1180,
            currentIndex: 0,
            showDownloadButton: true,
            "data-id": "components_HeroArticle_Slider"
          }), !showDownloadButton && __jsx(Slider, {
            heroes: media,
            showBullets: false,
            showPrimaryArrows: false,
            showSecondaryArrows: true,
            heightRatio: 664 / 1180,
            currentIndex: 0,
            "data-id": "components_HeroArticle_Slider_10"
          }));
          break;
      }
      return __jsx(Container, {
        "data-id": "components_HeroArticle_Container"
      }, El, credits && __jsx(Credits, {
        "data-id": "components_HeroArticle_Credits"
      }, credits), (type !== 'video' && author || type === 'video' && !showVideo) && author && __jsx(AuthorImageContainer, {
        "data-id": "components_HeroArticle_AuthorImageContainer"
      }, __jsx(UserAvatar, {
        mode: "imageLoader",
        size: renderWidth > breakpointSizes.md ? 'xlarge' : 'larger',
        name: author.name,
        imageUrl: author.image,
        "data-id": "components_HeroArticle_UserAvatar"
      })));
    }
  }]);
}(Component);
export default HeroArticle;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: relative;\n"])));
var Credits = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  ", ";\n  text-shadow: 0 0 20rem rgba(0, 0, 0, 0.5);\n  position: absolute;\n  max-width: 320rem;\n  z-index: 2;\n  left: 20rem;\n  bottom: 10rem;\n  color: white;\n  font-size: 12rem;\n  ", ";\n"])), textStyles.caption, fromBreakpoint.md(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    left: 60rem;\n    bottom: 20rem;\n    font-size: 14rem;\n  "]))));
var ImageContainer = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding-top: 56.25%;\n  position: relative;\n\n  > div {\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    &:after {\n      position: absolute;\n      content: ' ';\n      top: 0;\n      left: 0;\n      width: 100%;\n      height: 100%;\n      z-index: 2;\n      background: linear-gradient(rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2));\n    }\n  }\n"])));
var DownloadButtonBase = styled.button(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  position: relative;\n  transform: translateY(-50%) scale(1);\n  z-index: 10;\n  opacity: 1;\n  width: auto;\n  height: auto;\n  border-radius: 50%;\n  transition: opacity 0.2s ease-in-out;\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  -webkit-tap-highlight-color: transparent;\n  opacity: 1;\n  width: 100%;\n  left: 20px;\n  bottom: 20px;\n"])));
var Video = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  background-color: #000000;\n  padding-top: 56.25%;\n  width: 100%;\n  position: relative;\n"])));
var YouTubeIFrame = styled.iframe(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  z-index: 3;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  box-sizing: border-box;\n  background-size: cover;\n  background-position: center;\n  visibility: ", ";\n"])), function (props) {
  return props.showVideo || !props.desktop ? 'visible' : 'hidden';
});
var PlayIconWrapper = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%) scale(1.5);\n  transition: transform 0.35s ease-in-out;\n  z-index: 1;\n  opacity: 0.9;\n  cursor: pointer;\n  box-shadow: 0 0 200rem 0 rgba(0, 0, 0, 0.5);\n  border-radius: 50%;\n\n  svg {\n    float: left;\n  }\n\n  &:hover {\n    transform: translate(-50%, -50%) scale(1.6);\n  }\n"])));
var loadOutAnimation = keyframes(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  0% {\n    opacity: 1;\n    z-index: 1;\n  }\n\n  50% {\n    opacity: 0;\n  }\n\n  100% {\n    opacity: 0;\n    z-index: 0;\n  }\n"])));
var VideoPlaceholder = styled.div(_templateObject0 || (_templateObject0 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 0;\n  background-color: ", ";\n  box-sizing: border-box;\n  padding-top: 56.28%;\n  width: 100%;\n  background-size: cover;\n  background-position: center;\n  background-image: url(", ");\n  animation: ", ";\n  animation-fill-mode: forwards;\n\n  &:after {\n    content: '';\n    width: 100%;\n    height: 100%;\n    top: 0;\n    left: 0;\n    position: absolute;\n    background-color: #000000;\n    opacity: 0.15;\n  }\n"])), colorPalette.background, function (props) {
  return props.image;
}, function (props) {
  return props.showVideo ? css(_templateObject1 || (_templateObject1 = _taggedTemplateLiteral(["\n          ", " 1.2s ease-in\n        "])), loadOutAnimation) : '';
});
var AuthorImageContainer = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n  right: 20rem;\n  bottom: -20rem;\n\n  ", ";\n"])), fromBreakpoint.md(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n    right: 40rem;\n    bottom: -40rem;\n  "]))));